//Select Crear Taxo
export const TAXA_LEVEL_LOADED = 'TAXA_LEVEL_LOADED';
export const TAXA_LEVEL_LOADING = 'TAXA_LEVEL_LOADING';
export const TAXA_LEVEL_ERROR = 'TAXA_LEVEL_ERROR';

export const TAXONOMIAS_LOADING = 'TAXONOMIAS_LOADING';
export const TAXONOMIAS_LOADED = 'TAXONOMIAS_LOADED';
export const TAXONOMIAS_ERROR = 'TAXONOMIAS_ERROR';

export const CREAR_TAXONOMIA_LOADING = 'CREAR_TAXONOMIA_LOADING';
export const CREAR_TAXONOMIA_SUCCESS = 'CREAR_TAXONOMIA_SUCCESS';
export const CREAR_TAXONOMIA_ERROR = 'CREAR_TAXONOMIA_ERROR';

export const VER_INDI_USER_TAXA_LOADING = 'VER_INDI_USER_TAXA_LOADING';
export const VER_INDI_USER_TAXA_LOADED = 'VER_INDI_USER_TAXA_LOADED';
export const VER_INDI_USER_TAXA_ERROR = 'VER_INDI_USER_TAXA_ERROR';

export const TAXA_EDIT_LOADED = 'TAXA_EDIT_LOADED';
export const TAXA_EDIT_LOADING = 'TAXA_EDIT_LOADING';
export const TAXA_EDIT_ERROR = 'TAXA_EDIT_ERROR';
export const TAXA_EDIT_RESET = 'TAXA_EDIT_RESET';
/*-----------------------------Reino-----------------------------------*/
export const REINO_LOADING = 'REINO_LOADING';
export const REINO_LOADED = 'REINO_LOADED';
export const REINO_ERROR = 'REINO_ERROR';

export const CREAREINO_ERROR = 'CREAREINO_ERROR';
export const CREAREINO_LOADED = 'CREAREINO_LOADED';
export const CREAREINO_LOADING = 'CREAREINO_LOADING';

export const EDITAREINO_ERROR = 'EDITAREINO_ERROR';
export const EDITAREINO_LOADED = 'EDITAREINO_LOADED';
export const EDITAREINO_LOADING = 'EDITAREINO_LOADING';

export const DELETEREINO_ERROR = 'DELETEREINO_ERROR';
export const DELETEREINO_LOADED = 'DELETEREINO_LOADED';
export const DELETEREINO_LOADING = 'DELETEREINO_LOADING';
/*-----------------------------Filo-----------------------------------*/
export const FILO_LOADING = 'FILO_LOADING';
export const FILO_LOADED = 'FILO_LOADED';
export const FILO_ERROR = 'FILO_ERROR';

export const CREARFILO_ERROR = 'CREARFILO_ERROR';
export const CREARFILO_LOADED = 'CREARFILO_LOADED';
export const CREARFILO_LOADING = 'CREARFILO_LOADING';

export const EDITARFILO_ERROR = 'EDITARFILO_ERROR';
export const EDITARFILO_LOADED = 'EDITARFILO_LOADED';
export const EDITARFILO_LOADING = 'EDITARFILO_LOADING';

export const DELETEFILO_ERROR = 'DELETEFILO_ERROR';
export const DELETEFILO_LOADED = 'DELETEFILO_LOADED';
export const DELETEFILO_LOADING = 'DELETEFILO_LOADING';
/*-----------------------------Sub Filo-----------------------------------*/
export const SUBFILO_LOADING = 'SUBFILO_LOADING';
export const SUBFILO_LOADED = 'SUBFILO_LOADED';
export const SUBFILO_ERROR = 'SUBFILO_ERROR';

export const CREARSUBFILO_ERROR = 'CREARSUBFILO_ERROR';
export const CREARSUBFILO_LOADED = 'CREARSUBFILO_LOADED';
export const CREARSUBFILO_LOADING = 'CREARSUBFILO_LOADING';

export const EDITARSUBFILO_ERROR = 'EDITARSUBFILO_ERROR';
export const EDITARSUBFILO_LOADED = 'EDITARSUBFILO_LOADED';
export const EDITARSUBFILO_LOADING = 'EDITARSUBFILO_LOADING';

export const DELETESUBFILO_ERROR = 'DELETESUBFILO_ERROR';
export const DELETESUBFILO_LOADED = 'DELETESUBFILO_LOADED';
export const DELETESUBFILO_LOADING = 'DELETESUBFILO_LOADING';
/*-----------------------------Clase-----------------------------------*/
export const CLASE_LOADING = 'CLASE_LOADING';
export const CLASE_LOADED = 'CLASE_LOADED';
export const CLASE_ERROR = 'CLASE_ERROR';

export const CREARCLASE_ERROR = 'CREARCLASE_ERROR';
export const CREARCLASE_LOADED = 'CREARCLASE_LOADED';
export const CREARCLASE_LOADING = 'CREARCLASE_LOADING';

export const EDITARCLASE_ERROR = 'EDITARCLASE_ERROR';
export const EDITARCLASE_LOADED = 'EDITARCLASE_LOADED';
export const EDITARCLASE_LOADING = 'EDITARCLASE_LOADING';

export const DELETECLASE_ERROR = 'DELETECLASE_ERROR';
export const DELETECLASE_LOADED = 'DELETECLASE_LOADED';
export const DELETECLASE_LOADING = 'DELETECLASE_LOADING';
/*-----------------------------Infra Clase-----------------------------------*/
export const INFRACLASE_LOADING = 'INFRACLASE_LOADING';
export const INFRACLASE_LOADED = 'INFRACLASE_LOADED';
export const INFRACLASE_ERROR = 'INFRACLASE_ERROR';

export const CREARINFRACLASE_ERROR = 'CREARINFRACLASE_ERROR';
export const CREARINFRACLASE_LOADED = 'CREARINFRACLASE_LOADED';
export const CREARINFRACLASE_LOADING = 'CREARINFRACLASE_LOADING';

export const EDITARINFRACLASE_ERROR = 'EDITARINFRACLASE_ERROR';
export const EDITARINFRACLASE_LOADED = 'EDITARINFRACLASE_LOADED';
export const EDITARINFRACLASE_LOADING = 'EDITARINFRACLASE_LOADING';

export const DELETEINFRACLASE_ERROR = 'DELETEINFRACLASE_ERROR';
export const DELETEINFRACLASE_LOADED = 'DELETEINFRACLASE_LOADED';
export const DELETEINFRACLASE_LOADING = 'DELETEINFRACLASE_LOADING';
/*-----------------------------Orden-----------------------------------*/
export const ORDEN_LOADING = 'ORDEN_LOADING';
export const ORDEN_LOADED = 'ORDEN_LOADED';
export const ORDEN_ERROR = 'ORDEN_ERROR';

export const CREARORDEN_ERROR = 'CREARORDEN_ERROR';
export const CREARORDEN_LOADED = 'CREARORDEN_LOADED';
export const CREARORDEN_LOADING = 'CREARORDEN_LOADING';

export const EDITARORDEN_ERROR = 'EDITARORDEN_ERROR';
export const EDITARORDEN_LOADED = 'EDITARORDEN_LOADED';
export const EDITARORDEN_LOADING = 'EDITARORDEN_LOADING';

export const DELETEORDEN_ERROR = 'DELETEORDEN_ERROR';
export const DELETEORDEN_LOADED = 'DELETEORDEN_LOADED';
export const DELETEORDEN_LOADING = 'DELETEORDEN_LOADING';
/*-----------------------------Sub Orden-----------------------------------*/
export const SUBORDEN_LOADING = 'SUBORDEN_LOADING';
export const SUBORDEN_LOADED = 'SUBORDEN_LOADED';
export const SUBORDEN_ERROR = 'SUBORDEN_ERROR';

export const CREARSUBORDEN_ERROR = 'CREARSUBORDEN_ERROR';
export const CREARSUBORDEN_LOADED = 'CREARSUBORDEN_LOADED';
export const CREARSUBORDEN_LOADING = 'CREARSUBORDEN_LOADING';

export const EDITARSUBORDEN_ERROR = 'EDITARSUBORDEN_ERROR';
export const EDITARSUBORDEN_LOADED = 'EDITARSUBORDEN_LOADED';
export const EDITARSUBORDEN_LOADING = 'EDITARSUBORDEN_LOADING';

export const DELETESUBORDEN_ERROR = 'DELETESUBORDEN_ERROR';
export const DELETESUBORDEN_LOADED = 'DELETESUBORDEN_LOADED';
export const DELETESUBORDEN_LOADING = 'DELETESUBORDEN_LOADING';
/*-----------------------------Familia-----------------------------------*/
export const FAMILIA_LOADING = 'FAMILIA_LOADING';
export const FAMILIA_LOADED = 'FAMILIA_LOADED';
export const FAMILIA_ERROR = 'FAMILIA_ERROR';

export const CREARFAMILIA_ERROR = 'CREARFAMILIA_ERROR';
export const CREARFAMILIA_LOADED = 'CREARFAMILIA_LOADED';
export const CREARFAMILIA_LOADING = 'CREARFAMILIA_LOADING';

export const EDITARFAMILIA_ERROR = 'EDITARFAMILIA_ERROR';
export const EDITARFAMILIA_LOADED = 'EDITARFAMILIA_LOADED';
export const EDITARFAMILIA_LOADING = 'EDITARFAMILIA_LOADING';

export const DELETEFAMILIA_ERROR = 'DELETEFAMILIA_ERROR';
export const DELETEFAMILIA_LOADED = 'DELETEFAMILIA_LOADED';
export const DELETEFAMILIA_LOADING = 'DELETEFAMILIA_LOADING';
/*-----------------------------Sub Familia-----------------------------------*/
export const SUBFAMILIA_LOADING = 'SUBFAMILIA_LOADING';
export const SUBFAMILIA_LOADED = 'SUBFAMILIA_LOADED';
export const SUBFAMILIA_ERROR = 'SUBFAMILIA_ERROR';

export const CREARSUBFAMILIA_ERROR = 'CREARSUBFAMILIA_ERROR';
export const CREARSUBFAMILIA_LOADED = 'CREARSUBFAMILIA_LOADED';
export const CREARSUBFAMILIA_LOADING = 'CREARSUBFAMILIA_LOADING';

export const EDITARSUBFAMILIA_ERROR = 'EDITARSUBFAMILIA_ERROR';
export const EDITARSUBFAMILIA_LOADED = 'EDITARSUBFAMILIA_LOADED';
export const EDITARSUBFAMILIA_LOADING = 'EDITARSUBFAMILIA_LOADING';

export const DELETESUBFAMILIA_ERROR = 'DELETESUBFAMILIA_ERROR';
export const DELETESUBFAMILIA_LOADED = 'DELETESUBFAMILIA_LOADED';
export const DELETESUBFAMILIA_LOADING = 'DELETESUBFAMILIA_LOADING';
/*-----------------------------Tribu-----------------------------------*/
export const TRIBU_LOADING = 'TRIBU_LOADING';
export const TRIBU_LOADED = 'TRIBU_LOADED';
export const TRIBU_ERROR = 'TRIBU_ERROR';

export const CREARTRIBU_ERROR = 'CREARTRIBU_ERROR';
export const CREARTRIBU_LOADED = 'CREARTRIBU_LOADED';
export const CREARTRIBU_LOADING = 'CREARTRIBU_LOADING';

export const EDITARTRIBU_ERROR = 'EDITARTRIBU_ERROR';
export const EDITARTRIBU_LOADED = 'EDITARTRIBU_LOADED';
export const EDITARTRIBU_LOADING = 'EDITARTRIBU_LOADING';

export const DELETETRIBU_ERROR = 'DELETETRIBU_ERROR';
export const DELETETRIBU_LOADED = 'DELETETRIBU_LOADED';
export const DELETETRIBU_LOADING = 'DELETETRIBU_LOADING';
/*-----------------------------Genero-----------------------------------*/
export const GENERO_LOADING = 'GENERO_LOADING';
export const GENERO_LOADED = 'GENERO_LOADED';
export const GENERO_ERROR = 'GENERO_ERROR';

export const CREARGENERO_ERROR = 'CREARGENERO_ERROR';
export const CREARGENERO_LOADED = 'CREARGENERO_LOADED';
export const CREARGENERO_LOADING = 'CREARGENERO_LOADING';

export const EDITARGENERO_ERROR = 'EDITARGENERO_ERROR';
export const EDITARGENERO_LOADED = 'EDITARGENERO_LOADED';
export const EDITARGENERO_LOADING = 'EDITARGENERO_LOADING';

export const DELETEGENERO_ERROR = 'DELETEGENERO_ERROR';
export const DELETEGENERO_LOADED = 'DELETEGENERO_LOADED';
export const DELETEGENERO_LOADING = 'DELETEGENERO_LOADING';
/*-----------------------------Especie-----------------------------------*/
export const ESPECIE_LOADING = 'ESPECIE_LOADING';
export const ESPECIE_LOADED = 'ESPECIE_LOADED';
export const ESPECIE_ERROR = 'ESPECIE_ERROR';

export const CREARESPECIE_ERROR = 'CREARESPECIE_ERROR';
export const CREARESPECIE_LOADED = 'CREARESPECIE_LOADED';
export const CREARESPECIE_LOADING = 'CREARESPECIE_LOADING';

export const EDITARESPECIE_ERROR = 'EDITARESPECIE_ERROR';
export const EDITARESPECIE_LOADED = 'EDITARESPECIE_LOADED';
export const EDITARESPECIE_LOADING = 'EDITARESPECIE_LOADING';

export const DELETESPECIE_ERROR = 'DELETESPECIE_ERROR';
export const DELETESPECIE_LOADED = 'DELETESPECIE_LOADED';
export const DELETESPECIE_LOADING = 'DELETESPECIE_LOADING';